import { FrontendLoggerService } from '../../../services/frontend-logger.service';
import { DocumentTypePresentation, UploadFile } from './upload.models';

export class UploadFileSelectionCoordinator {
  constructor(private readonly logger: FrontendLoggerService) {}

  setupDropZone(dropZone: HTMLElement | undefined, accept: (files: FileList) => void): void {
    if (!dropZone) {
      return;
    }
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      dropZone.addEventListener(eventName, (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });
    ['dragenter', 'dragover'].forEach((eventName) => {
      dropZone.addEventListener(eventName, () => dropZone.classList.add('drag-over'));
    });
    ['dragleave', 'drop'].forEach((eventName) => {
      dropZone.addEventListener(eventName, () => dropZone.classList.remove('drag-over'));
    });
    dropZone.addEventListener('drop', (event: DragEvent) => {
      if (event.dataTransfer?.files) {
        accept(event.dataTransfer.files);
      }
    });
  }

  select(
    fileList: FileList,
    presentations: Record<string, DocumentTypePresentation>,
    tags: string[]
  ): UploadFile[] {
    return Array.from(fileList).flatMap((file) => {
      const extension = file.name.split('.').pop()?.toLowerCase() || '';
      if (!presentations[extension]) {
        this.logger.error(`[UploadComponent] Tipo de archivo no soportado: ${extension}`);
        return [];
      }
      return [{
        id: Date.now().toString() + Math.random().toString(36).substring(2, 7),
        file,
        progress: 0,
        status: 'pending' as const,
        tags: [...tags]
      }];
    });
  }
}
